export const calculateLayout = (offsetLayout: OffsetLayout, span: number) => {
    return {
        xs: { offset: offsetLayout.xs, span: span - offsetLayout.xs * 2 },
        md: { offset: offsetLayout.md, span: span - offsetLayout.md * 2 },
        lg: { offset: offsetLayout.lg, span: span - offsetLayout.lg * 2 },
        xl: { offset: offsetLayout.xl, span: span - offsetLayout.xl * 2 },
        xxl: { offset: offsetLayout.xxl, span: span - offsetLayout.xxl * 2 }
    };
};